import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks/useStores';
import SearchTab from '../SearchTab';
import GeoSuggest from '../GeoSuggest';
import TypeOfTransport from '../TypeOfTransport';
import TypeOfAdvert from '../TypeOfAdvert';
import Brand from '../Brand';
import Model from '../Model';

import { Item } from '../SearchTab/SearchTabStyles';
import { MarkAndModelContainer } from '../../SearchStyles';

const PurchaseSearchTab = observer(() => {
  const {
    findTrucksStore: { countHideFilledFields },
  } = useStores();

  return (
    <SearchTab countHideFilledFields={countHideFilledFields} isShow={false} isProposals>
      <Item className="select-advert-type">
        <TypeOfAdvert />
      </Item>
      <MarkAndModelContainer>
        <div className="wrapper">
          <Item className="brand-item">
            <Brand />
          </Item>
          <Item className="model-item">
            <Model />
          </Item>
        </div>
      </MarkAndModelContainer>
      <Item className="geo-block">
        <GeoSuggest />
      </Item>
      <Item className="type-block">
        <TypeOfTransport />
      </Item>
    </SearchTab>
  );
});

export default PurchaseSearchTab;
